import { useRef, useState, useEffect } from "react";
import { FaBars, FaTimes, FaChevronLeft, FaChevronRight, FaSignOutAlt } from "react-icons/fa";
import { FaFileAlt, FaHistory, FaUsers, FaUser, FaComments, FaTelegram, FaRobot } from "react-icons/fa";
import { GrDocumentConfig } from "react-icons/gr";
import { useNavigate} from "react-router-dom";
import { IoPersonAddSharp } from "react-icons/io5";
import { FaBook } from "react-icons/fa";
import { FaTasks } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { LuFileScan } from "react-icons/lu";




import { useAuth } from "../auth/Auth";
import axios from 'axios';

import "../header/Header.css";

function Header() {
    const navRef = useRef();
    const { user, logout } = useAuth()
    const userRule = user?.role;
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('refreshToken'));
    const [isExpanded, setIsExpanded] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response && error.response.status === 401) {
                    setIsLoggedIn(false);
                    navigate('/Login');
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axios.interceptors.response.eject(interceptor);
        };
    }, [navigate]);

    const showSidebar = () => {
        navRef.current.classList.toggle("responsive_nav");
    };

    const handleMouseEnter = () => {
        setIsExpanded(true);
    };

    const handleMouseLeave = (e) => {
        const header = e.currentTarget;
        const relatedTarget = e.relatedTarget;
        
        if (relatedTarget instanceof Node && !header.contains(relatedTarget)) {
            setIsExpanded(false);
        }
    };

    const toggleSidebar = () => {
        setIsExpanded(!isExpanded);
    };

    const handleLogout = () => {
        logout();
        setIsLoggedIn(false);
        navigate('/Login');
    };

    return (
        <>
            <header 
                className={isExpanded ? "expanded" : "collapsed"}
                onMouseLeave={handleMouseLeave}
            >
                <h2>{isExpanded ? "Bank statement" : ""}</h2>
                <nav ref={navRef}>
                    {isLoggedIn ? (
                        <>
                            <div className="nav-links">

                                <a id="characters" href="/ConversionFiles" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Оригінальні файли виписок" : <LuFileScan />
                                    }
                                </a>

                                <a id="characters" href="/FopForm" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Створення FOP запису" : <LuFileScan />
                                    }
                                </a>
                               
                                <a id="characters" href="/RestForm" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Операції" : <IoPersonAddSharp />}
                                </a>
                                <a id="characters" href="/Directory" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Довідник" : <FaBook />
                                    }
                                </a>
                                
                                <a id="characters" href="/Info" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Email" : <MdEmail />

                                    }
                                </a>
                                <a id="characters" href="/AdminProfile" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Користувачі" : <FaUsers />

                                    }
                                </a>
                                <a id="characters" href="/HistorydA" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Історія" : <FaHistory />}
                                </a>
                                <a id="characters" href="/Bot" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Bot" : <FaRobot />}
                                </a>
                               
                               
                                <a id="starships" href="/Profile" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Реєстр заявок" : <FaTasks />}
                                </a>
                     
                                <a id="characters" href="/Events" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Журнал подій" : <FaFileAlt />}
                                </a>
                                <a id="characters" href="/UserConfig" onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Конфіги Юзерів" : <GrDocumentConfig />}
                                </a>
                                <a id="logout" onClick={handleLogout} onMouseEnter={handleMouseEnter}>
                                    {isExpanded ? "Вихід" : <FaSignOutAlt />}
                                </a>
                            </div>
                        </>
                    ) : (
                        <a id="login" href="/Login">
                            Login
                        </a>
                    )}
                    <button className="nav-btn nav-close-btn" onClick={showSidebar}>
                        <FaTimes />
                    </button>
                </nav>
                <button className="nav-btn" onClick={showSidebar}>
                    <FaBars />
                </button>
                <button className="toggle-btn" onClick={toggleSidebar}>
                    {isExpanded ? <FaChevronLeft /> : <FaChevronRight />}
                </button>
            </header>
            <div className="top-bar">
                <div className="top-bar-content">
                    <div className="phone-number">тел. 0 67 333 98 80 (07:00 - 01:00)</div>
                    <div className="top-bar-buttons">
                       
                    <a href="https://t.me/SyrveSupport_dao_chatmanager" target="_blank" rel="noopener noreferrer" className="top-bar-btn telegram-btn">
                            <FaTelegram className="btn-icon" />
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Header;